<template>
  <div class="admin-dashboard" v-if="role == 'admin'">
    <v-card class="main-card d-flex justify-space-between align-center pa-6">
      <div style="width: 100%">
        <div class="fs-xxlarge mb-4">ادمین گرامی، خوش آمدید!</div>

        <div class="buttons-box mt-15 mb-5">
          <v-row>
            <v-col>
              <v-btn
                to="/users"
                class="dashboard-button mb-md-0 mb-8"
                height="200"
                ><b class="fs-xlarge primary--text d-flex flex-column"
                  ><v-icon x-large color="primary" class="mb-2"
                    >mdi-account-group</v-icon
                  >مشاهده کاربران</b
                ></v-btn
              >
            </v-col>
            <v-col>
              <v-btn to="/pies" class="dashboard-button" height="200"
                ><b class="fs-xlarge primary--text d-flex flex-column"
                  ><v-icon x-large color="primary" class="mb-2"
                    >mdi-currency-usd</v-icon
                  >مشاهده کیک‌های سهام</b
                ></v-btn
              >
            </v-col>
            <v-col>
              <v-btn to="/purchases" class="dashboard-button" height="200"
                ><b class="fs-xlarge primary--text d-flex flex-column"
                  ><v-icon x-large color="primary" class="mb-2">mdi-cart</v-icon
                  >لیست درخواست‌ها</b
                ></v-btn
              >
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
  </div>
  <div v-else>
    <div class="py-10 text-center fs-xxlarge grey--text d-flex flex-column">
      <v-icon style="font-size: 4rem" class="mb-4 grey--text"
        >mdi-alert-outline</v-icon
      >
      دسترسی شما به این صفحه امکان‌پذیر نمی‌باشد!
    </div>
  </div>
</template>

<script>
export default {
  name: "Dashboard",

  data() {
    return {
      role: "",
    };
  },

  mounted() {
    this.role = localStorage.getItem("role");
  },

  methods: {},
};
</script>

<style lang="scss">
.admin-dashboard {
  .main-card {
  }
  .dashboard-button {
    background: rgb(235, 235, 235);
    background: linear-gradient(
      209deg,
      rgba(235, 235, 235, 1) 0%,
      rgb(236, 213, 213) 100%
    );
    border-radius: 12px;
    width: 100%;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px !important;
  }
}
</style>
